import LOGO from "../images/IrrigacionAgricola.png";

export const Team__IrrigacionAgricola = {
  name: "Irrigacion Agricola",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#2F6DB5",
  teamJerseyColor: "#8CC63E",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 49 + 43 + 36,
  goalsScoredAgainst: 61 + 54 + 48,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  dontShowPointDif: true,

  players: [],
};
